export default __webpack_public_path__ + "static/media/go-maxi.e85187e7.glb";